import { FETCH_INVOICES, FETCH_INVOICES_SUCCESS, FETCH_INVOICES_ERROR, 
  TOGGLE_INVOICE, TOGGLE_ALL_INVOICES, CHANGE_PAYMENT_AMOUNT, CHANGE_ADHOC_PAYMENT,RESET_PAYMENT_AMOUNT,PAYMENT_TYPE,TOTAL_INVOICE_AMOUNT} from '../action-types/invoice';

export const fetchInvoices = (currencyCode) => {

  return async dispatch => {
    try {
      dispatch({
        type: FETCH_INVOICES
      })

      let token = localStorage.getItem('token');
      let code = localStorage.getItem('code');
      const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_INVOICES_URL}?invoice-code=${currencyCode}&customer-code=${encodeURIComponent(code)}&type=Invoice`,
      {
        method: 'GET',
        headers: {        
          Authorization: `${process.env.REACT_APP_API_TOKEN}`
        }})
      //const response = await fetch(`${'https://api.myjson.com/bins/oq7ly'}?token=${token}&code=${code}&currency=${currencyCode}`)
      const data = await response.json();
      if (data && data.length) {
        dispatch({type: FETCH_INVOICES_SUCCESS, payload: data.map(invoice => {
          return {...invoice, selected: false}
        }),currencyCode:currencyCode})
      } else {
        dispatch({type: FETCH_INVOICES_ERROR, payload: data})
      }
    } catch(error) {
      dispatch({type: FETCH_INVOICES_ERROR, payload: 'Server unreachable, Please contact customer support'})
    }
  }
}

export const toggleInvoice = (entryNo) => {
  return dispatch => {
    dispatch({type: TOGGLE_INVOICE, payload: entryNo});
  }
}

export const toggleAllInvoices = (checked,invoices) => {
  return dispatch => {
    dispatch({type: TOGGLE_ALL_INVOICES, payload: {checked, invoices}});
  }
}

export const changePaymentAmount = (entryNo, paymentAmount) => {
  return dispatch => {
    dispatch({type: CHANGE_PAYMENT_AMOUNT, payload: {entryNo, paymentAmount}});
  }
}

export const changeAdhocAmount = (adhocPaymentEnabled, adhocPayment) => {
  return dispatch => {
    dispatch({type: CHANGE_ADHOC_PAYMENT, payload: {adhocPaymentEnabled, adhocPayment}});
  }
}

export const resetCheckPaymentAmount = (invoice) => {
    return dispatch => {
      dispatch({type: RESET_PAYMENT_AMOUNT, payload: invoice});
    }
}

export const getPaymentType = (payment) =>{
  return dispatch => {
    dispatch({type: PAYMENT_TYPE, payload: payment});
  }
}

export const getTotalInvoiceAmount = (totalInvoiceAmount) => {
      return dispatch => {
        dispatch({type:TOTAL_INVOICE_AMOUNT,payload:totalInvoiceAmount})
      }
}


// WEBPACK FOOTER //
// ./src/actions/invoice.js